import {
    Bandeira, Clientes, DadosBorderoGeral, DadosRelLanctoCartao, error99, LanctoCartao, LanctoCartaoaAttributes,
    LanctoContaPag, ParamsEstLanctoCartao, ParamsLiqLanctoCartao, RetAPI, Usuarios
} from "../../Utils/Types"
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export const LanctoCartaoService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('LanctoCartao/Attributes', 'get', { id })
        const attributes: LanctoCartaoaAttributes = {
            bandeira: [],
            cliente: [],
            vendedor: [],
            lanctoCartao: {
                id: 0,
                id_empresa: 0,
                id_user_insert: 0,
                id_user_last_update: 0,
                id_user_exclusao: 0,
                id_venda: 0,
                dt_chegada: '',
                dt_vencimento: '',
                dt_cadastro: '',
                dt_last_update: '',
                dh_exclusao: '',
                motivo_exclusao: '',
                name_user_insert: '',
                name_user_last_update: '',
                name_user_delete: '',
                hora: '',
                valor: 0,
                valor_receber: 0,
                id_bandeira: 0,
                numero_transacao: '',
                id_cliente: 0,
                id_bordero: 0,
            }
        }

        if (resp.data) {

            let bandeira: Bandeira[] = []
            let vendedor: Usuarios[] = []
            let cliente: Clientes[] = []

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.bandeira) {

                    bandeira = resp.data.bandeira.map((item: any) => {
                        return {
                            id: item.id,
                            description: item.nome
                        }
                    })
                    attributes.bandeira = bandeira

                }

                if (resp.data.vendedor) {

                    vendedor = resp.data.vendedor.map((item: any) => {
                        return {
                            id: item.id,
                            description: item.nome
                        }
                    })
                    attributes.vendedor = vendedor

                }

                if (resp.data.cliente) {

                    cliente = resp.data.cliente.map((item: any) => {
                        return {
                            id: item.id,
                            description: item.nome
                        }
                    })
                    attributes.cliente = cliente

                }

                if (resp.data.cartao) {


                    attributes.lanctoCartao.id = resp.data.cartao.id
                    attributes.lanctoCartao.id_empresa = resp.data.cartao.id_empresa
                    attributes.lanctoCartao.id_user_insert = resp.data.cartao.id_user_insert
                    attributes.lanctoCartao.id_user_last_update = resp.data.cartao.id_user_last_update
                    attributes.lanctoCartao.id_user_exclusao = resp.data.cartao.id_user_exclusao
                    attributes.lanctoCartao.id_venda = resp.data.cartao.id_venda
                    attributes.lanctoCartao.dt_chegada = resp.data.cartao.dt_chegada
                    attributes.lanctoCartao.dt_vencimento = resp.data.cartao.dt_vencimento
                    attributes.lanctoCartao.dt_cadastro = resp.data.cartao.dt_cadastro
                    attributes.lanctoCartao.dt_last_update = resp.data.cartao.dt_last_update
                    attributes.lanctoCartao.dh_exclusao = resp.data.cartao.dh_exclusao
                    attributes.lanctoCartao.motivo_exclusao = resp.data.cartao.motivo_exclusao
                    attributes.lanctoCartao.name_user_insert = resp.data.cartao.name_user_insert
                    attributes.lanctoCartao.name_user_last_update = resp.data.cartao.name_user_last_update
                    attributes.lanctoCartao.name_user_delete = resp.data.cartao.name_user_delete
                    attributes.lanctoCartao.hora = resp.data.cartao.hora
                    attributes.lanctoCartao.valor = resp.data.cartao.valor
                    attributes.lanctoCartao.valor_receber = resp.data.cartao.valor_receber
                    attributes.lanctoCartao.id_bandeira = resp.data.cartao.id_bandeira
                    attributes.lanctoCartao.numero_transacao = resp.data.cartao.numero_transacao
                    attributes.lanctoCartao.id_cliente = resp.data.cartao.id_cliente
                    attributes.lanctoCartao.id_bordero = resp.data.cartao.id_bordero

                }
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }

    },

    Save: async (lanctoCartao: any): Promise<RetAPI> => {

        let id = ''

        if (lanctoCartao.id) {
            id = lanctoCartao.id.toString()
        }

        const resp = await Api('LanctoCartao/Save', 'post', {

            numero_transacao: lanctoCartao.numero_transacao,
            dt_chegada: lanctoCartao.dt_chegada,
            dt_vencimento: lanctoCartao.dt_vencimento,
            valor: lanctoCartao.valor,
            valor_receber: lanctoCartao.valor_receber,
            id_bandeira: lanctoCartao.id_bandeira,
            id_cliente: lanctoCartao.id_cliente,
            id
        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: 'Dados do lançamento gravados com sucesso',
                id: resp.data.lanctoCartao.id,
                data: resp.data,
                dt_cadastro: resp.data.lanctoCartao.dt_cadastro,
                dt_last_update: resp.data.lanctoCartao.dt_last_update,
                name_user_insert: resp.data.lanctoCartao.name_user_insert,
                name_user_last_update: resp.data.lanctoCartao.name_user_last_update
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`LanctoCartao/Delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }


    },

    Filter: async (filterLanctoCartao?: any): Promise<RetAPI> => {

        const resp = await Api('LanctoCartao/Filter', 'get', {
            dt_ini: filterLanctoCartao?.dt_ini,
            dt_fim: filterLanctoCartao?.dt_fim,
            tipo: filterLanctoCartao?.tipo,
            status: filterLanctoCartao?.status,
            id_bandeira: filterLanctoCartao?.id_bandeira,
            id_vendedor: filterLanctoCartao?.id_vendedor,
            id_cliente: filterLanctoCartao?.id_cliente,
        })

        let cartao: DadosRelLanctoCartao = { lanctoCartao: [], qtd: 0, total: 0 }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: cartao
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                cartao.qtd = resp.data.quantidade_total
                cartao.total = resp.data.valor_total

                resp.data.lanctoCartao.map((item: any) => {
                    return cartao.lanctoCartao.push({
                        id: item.id,
                        id_empresa: item.id_empresa,
                        id_user_insert: item.id_user_insert,
                        id_venda: item.id_venda,
                        id_bandeira: item.id_bandeira,
                        id_cliente: item.id_cliente,
                        id_bordero: item.id_bordero,
                        dt_chegada: item.dt_chegada,
                        dt_vencimento: item.dt_vencimento,
                        dt_cadastro: item.dt_cadastro,
                        name_user_insert: item.nome_vendedor,
                        name_bandeira: item.nome_bandeira,
                        name_cliente: item.nome_cliente,
                        hora: item.hora,
                        valor: item.valor,
                        valor_receber: item.valor_receber,
                        numero_transacao: item.numero_transacao,

                    })
                })
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: cartao
            }
        }

        return {
            error: false,
            data: cartao
        }

    },

    FilterBordero: async (filterLanctoCartao?: any): Promise<RetAPI> => {

        const resp = await Api('LanctoCartao/Filter/Bordero', 'get', {
            dt_ini: filterLanctoCartao?.dt_ini,
            dt_fim: filterLanctoCartao?.dt_fim,
            tipo: filterLanctoCartao?.tipo,
            status: filterLanctoCartao?.status,
            id_bandeira: filterLanctoCartao?.id_bandeira,
            id_vendedor: filterLanctoCartao?.id_vendedor,
            id_cliente: filterLanctoCartao?.id_cliente,
            bordero: filterLanctoCartao?.bordero
        })

        const dadosBordero: DadosBorderoGeral = { lanctoCartao: [], qtd: 0, total: 0 }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dadosBordero
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                dadosBordero.qtd = resp.data.quantidade_total
                dadosBordero.total = resp.data.valor_total

                resp.data.lanctoCartao.map((item: any) => {
                    return dadosBordero.lanctoCartao.push({

                        valor: item.valor,
                        valor_receber: item.valor_receber,
                        id_bordero: item.id_bordero,
                        dt_baixa: item.dt_baixa,
                        nome_cliente: item.nome_cliente,
                        obs_baixa: item.obs_baixa,
                        qtd: item.qtd
                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dadosBordero
            }
        }

        return {
            error: false,
            data: dadosBordero
        }

    },

    FilterExcluidas: async (filterLanctoCartao?: any): Promise<RetAPI> => {

        const resp = await Api('LanctoCartao/Filter/Excluidas', 'get', {
            dt_ini: filterLanctoCartao?.dt_ini,
            dt_fim: filterLanctoCartao?.dt_fim,
            nome_cliente: filterLanctoCartao?.nome_cliente,
        })

        let cartao: LanctoCartao[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: cartao
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.lanctoCartao.map((item: any) => {
                    return cartao.push({
                        id: item.id,
                        id_empresa: item.id_empresa,
                        id_user_insert: item.id_user_insert,
                        id_venda: item.id_venda,
                        id_bandeira: item.id_bandeira,
                        id_cliente: item.id_cliente,
                        id_bordero: item.id_bordero,
                        id_user_exclusao: item.id_user_exclusao,
                        id_user_last_update: item.id_user_last_update,
                        dt_chegada: item.dt_chegada,
                        dt_vencimento: item.dt_vencimento,
                        dt_cadastro: item.dt_cadastro,
                        dh_exclusao: item.dh_exclusao,
                        name_user_insert: item.nome_vendedor,
                        name_user_delete: item.name_user_delete,
                        name_bandeira: item.nome_bandeira,
                        name_cliente: item.nome_cliente,
                        hora: item.hora,
                        valor: item.valor,
                        valor_receber: item.valor_receber,
                        numero_transacao: item.numero_transacao,
                        motivo_exclusao: item.motivo_exclusao

                    })
                })
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: cartao
            }
        }

        return {
            error: false,
            data: cartao
        }

    },

    Liquidar: async (params: ParamsLiqLanctoCartao): Promise<RetAPI> => {

        const random = uuid()

        params.senha_usuario = base64_encode(params.senha_usuario + '-' + random)

        const resp = await Api('LanctoCartao/Liquidar', 'put', params)

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Estornar: async (params: ParamsEstLanctoCartao): Promise<RetAPI> => {

        const random = uuid()

        params.senha_usuario = base64_encode(params.senha_usuario + '-' + random)

        const resp = await Api('LanctoCartao/Estornar', 'put', params)

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || ''
                }
            }

            return {
                error: false,
                msg: ''
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    BuscarPagamentos: async (bordero: number[]): Promise<RetAPI> => {

        const resp = await Api(`LanctoCartao/DadosPag?bordero=${bordero}`, 'get',)
        const dados: LanctoContaPag[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dados
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.pagLanctoCartao.map((item: any) => {
                    return dados.push({
                        description: item.descricao,
                        id_conta: item.id_conta,
                        valor: item.valor,
                    })
                })
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dados
            }
        }

        return {
            error: false,
            msg: resp.data.msg || '',
            data: dados,
        }

    },

    
}